export default __webpack_public_path__ + "static/media/himalayan.95653d76.jpeg";